import styled from 'styled-components';

import { Box } from '@/components/Box';

export const Wrapper = styled(Box)`
  width: 100%;
  position: relative;
`;

export const IconContainer = styled(Box)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  z-index: 1;
  width: 24px;
`;

export const Label = styled.span`
  position: absolute;
  left: 0;
`;
